import { useQuery, useMutation } from "@tanstack/react-query";
import { api } from "@/utils/axiosInterceptor";
import { Invoice, invoiceList } from "@/types/invoices";

export const useInvoices = () => {
	const {
		data: invoices,
		isLoading,
		error,
	} = useQuery({
		queryKey: ["invoices"],
		queryFn: async () => {
			const response = await api.get<invoiceList[]>("/invoices")
			return response;
		},
		select: (data) => {
			return [...data.data].sort(
			  (a, b) =>
				new Date(`${b.invoiceTime}`).getTime() -
				new Date(`${a.invoiceTime}`).getTime()
			);
		  }
	});

	const createInvoiceMutation = useMutation({
		mutationFn: (data: {isConsolidatedInvoice: boolean, invoices: Omit<Invoice, "id">, prefixId: string | undefined}) => 
            api.post<Invoice>(`/invoice?isConsolidatedInvoice=${data.isConsolidatedInvoice}&prefixId=${data.prefixId}`, data.invoices),
	});

	const updateInvoiceMutation = useMutation({
		mutationFn: (data: {id: string, invoice: Partial<Invoice>}) =>
			api.put<Partial<Invoice>>(`/invoice/${data.id}`, data.invoice)
	});

	const deleteInvoiceMutation = useMutation({
		mutationFn: (id: string) => api.delete(`/invoices/${id}`),
	});

	const deleteConsolidateInvoiceLineItemMutation = useMutation({
		mutationFn: (data: {invoiceId: string, lineItemId: string}) => api.delete(`/invoice/${data.invoiceId}/item/${data.lineItemId}`)
	})

	const cloneInvoice = useMutation({
		mutationFn: (invoiceIdsToBeClone: string[]) => api.post("/invoice/clone-document", { cloneDocumentId: invoiceIdsToBeClone })
	})

	return {
		invoices,
		createInvoiceAsync: createInvoiceMutation.mutateAsync,
		isCreatingInvoice: createInvoiceMutation.isPending,
		updateInvoice: updateInvoiceMutation.mutateAsync,
		isUpdatingInvoice: updateInvoiceMutation.isPending,
		deleteInvoiceAsync: deleteInvoiceMutation.mutateAsync,
		deleteConsolidateItem: deleteConsolidateInvoiceLineItemMutation.mutate,
		cloneInvoice: cloneInvoice.mutate,
		isLoading,
		error,
	};
};
